export default __webpack_public_path__ + "static/media/gremlin-logo-white.d03b5d3d6d3abd2ff15f8d15b4925686.svg";